"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasValidSession = exports.removeSession = exports.setSession = void 0;
var storage_1 = require("../../build-babel/token/storage");
var cookie_1 = require("../../build-babel/token/cookie");
var redirect_1 = require("../../build-babel/redirect");
var token_1 = require("../../build-babel/token");
var setSession = function setSession(token, baseUrl) {
  (0, storage_1.setToken)(token);
  (0, cookie_1.setCookie)(token, baseUrl);
};
exports.setSession = setSession;
var removeSession = function removeSession(baseUrl) {
  var isRemoveRedirectUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  (0, storage_1.removeToken)();
  (0, cookie_1.removeCookie)(baseUrl);
  isRemoveRedirectUrl && (0, redirect_1.removeRedirectUrl)();
};
exports.removeSession = removeSession;
var hasValidSession = function hasValidSession(baseUrl) {
  if (!(0, cookie_1.hasCookie)(baseUrl)) return false;
  if ((0, storage_1.hasToken)()) {
    var token = (0, storage_1.getToken)();
    return (0, token_1.hasValidToken)(token);
  }
  return false;
};
exports.hasValidSession = hasValidSession;
//# sourceMappingURL=index.js.map